import React from 'react'
import {useSelector} from 'react-redux'
import { Navigate } from 'react-router-dom'

import BreadcrumbDetailed from 'components/Common/BreadcrumbDetailed'
import './my-card.scss'
import { decodeJWT, getLocalStorageValue } from 'config/helper'

function MyCard() {
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

  const headerSectionData = useSelector(
    ({common}) => common.commonDetailsData.header_section
  )

  if (!isUserLoggedIn) {
    return <Navigate to="/login" />
  }

  const breadcrumbList = [{lable: 'My Card', link: '', searchTag: ''}]

  const userToken = getLocalStorageValue("user-token")
  const decodedToken = decodeJWT(userToken)
  const username = decodedToken?.username?.replace("@example.com", "")


  return (
    <>
      <BreadcrumbDetailed breadcrumbList={breadcrumbList} title='My Card' />
      <div className='my-card-wrap'>
        <div className='container'>
          <div className='logo'>
            {headerSectionData && headerSectionData.rsa_client_logo ? (
              <img
                src={headerSectionData.rsa_client_logo}
                alt={headerSectionData.image_alt_text}
              />
            ) : (
              ''
            )}
          </div>
          <p>Your Phone Number :</p>
          <span>{username}</span>
          <p>
            Enter your phone number at checkout to redeem the coupons and
            rewards
          </p>
        </div>
      </div>
    </>
  )
}

export default MyCard
